import { Routes } from '@angular/router';
import { CurrentUserComponent } from './components/current-user/current-user.component';
import { EmailConfirmedComponent } from './components/email-confirmed/email-confirmed.component';
import { EmailErrorComponent } from './components/email-error/email-error.component';
import { InvalidRoleComponent } from './components/invalid-role/invalid-role.component';
import { OrganizationConfirmedComponent } from './components/organization-confirmed/organization-confirmed.component';
import { OrganizationErrorComponent } from './components/organization-error/organization-error.component';
import { SigninRedirectCallbackComponent } from './components/signin-redirect-callback/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from './components/signout-redirect-callback/signout-redirect-callback.component';
import { HomeComponent } from './home/home.component';
import { AlertsComponent } from './pages/alerts/alerts.component';
import { DashboardAdminComponent } from './pages/dashboard-admin/dashboard-admin.component';
import { DashboardClinicComponent } from './pages/dashboard-clinic/dashboard-clinic.component';
import { DepartmentsComponent } from './pages/departments/departments.component';
import { OrganizationsComponent } from './pages/organizations/organizations.component';
import { PatientsComponent } from './pages/patients/patients.component';
import { PersonalComponent } from './pages/personal/personal.component';
import { ServicesComponent } from './pages/services/services.component';
import { SummaryPatientComponent } from './pages/summary-patient/summary-patient.component';
import { UsersComponent } from './pages/users/users.component';
import { WorkersComponent } from './pages/workers/workers.component';

export const routes: Routes = [
  { path: '', component: HomeComponent},
      { path: 'alerts', component: AlertsComponent},
      { path: 'currentuser', component: CurrentUserComponent },
      { path: 'dashboard-admin', component: DashboardAdminComponent },
      { path: 'dashboard-clinic', component: DashboardClinicComponent },
      { path: 'departments', component: DepartmentsComponent },
      { path: 'invalid-role', component: InvalidRoleComponent },
      { path: 'organizations', component: OrganizationsComponent },
      { path: 'patients', component: PatientsComponent },
      { path: 'personal', component: PersonalComponent },
      { path: 'services', component: ServicesComponent },
      { path: 'summary', component: SummaryPatientComponent },
      { path: 'users', component: UsersComponent },
      { path: 'workers', component: WorkersComponent },
      // Componenti di conferma delle email
      { path: 'email-confirmed', component: EmailConfirmedComponent },
      { path: 'email-error', component: EmailErrorComponent },
      { path: 'organization-confirmed', component: OrganizationConfirmedComponent },
      { path: 'organization-error', component: OrganizationErrorComponent },
  { path: 'signin-callback', component: SigninRedirectCallbackComponent },
  { path: 'signout-callback', component: SignoutRedirectCallbackComponent }
];
